import React from 'react';
import SavedDashboardHOC from '@components/common/SavedDashboardsHOC';
import { useDispatch } from 'react-redux';
import { createSavedDashboard } from '@store/tempDashboard/actions';
import NocContainer from './NocContainer';
import { PAGE_TYPE } from '@utils/constants';
import { filterAndApplyState } from '@store/noc/base/actions';

function NocSavedDashboard(props) {
  const dispatch = useDispatch();
  const applySavedDataToNoc = (payload) => {
    let data = null;
    const { config } = payload;
    const { nocStore } = config;

    if (nocStore) {
      data = nocStore;
    } else if (config.base) {
      data = config.base;
    }

    dispatch(filterAndApplyState(data));
    dispatch(
      createSavedDashboard(payload.id, payload.name, payload.dashboardType.id, payload.config),
    );
  };

  return (
    <SavedDashboardHOC {...props} applySavedData={applySavedDataToNoc}>
      {(props) => {
        return (
          <NocContainer
            {...props}
            // sd-rt: replace with isSavedDashboard prop
            pageType={PAGE_TYPE.SAVED_DASHBOARD}
          />
        );
      }}
    </SavedDashboardHOC>
  );
}

export default NocSavedDashboard;
